module.exports = __webpack_public_path__ + "img/letraO.964f85e6.png";